import styled from "styled-components";
import {
  EventContentBody,
  EventContentScrollArea,
  EventPageHeader,
  EventPageWrapper,
  EventPaginationBox,
} from "../../event/shared/page-layout";

export const PageWrapper = EventPageWrapper;
export const PageHeaderArea = EventPageHeader;
export const ContentScrollArea = EventContentScrollArea;
export const ContentBody = EventContentBody;
export const PaginationBox = EventPaginationBox;

export const Title = styled.div`
  color: #121212;
  font-family: Pretendard;
  font-size: 35px;
  font-weight: 700;
`;

export const TableSection = styled.div`
  margin-top: 20px;
`;

export const TableWrapper = styled.div`
  width: 100%;
  padding: 20px 30px 24px;
  box-sizing: border-box;
  border-radius: 14px;
  border: 0.707px solid #d9d9d9;
  background: #fff;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
`;

export const FilterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 16px;
`;

export const DateRange = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;

  > input {
    width: 140px;
    height: 40px;
    padding: 0 10px;
    border: 1px solid #ccc;
    border-radius: 10px;
    font-family: Pretendard;
    font-size: 13px;
    color: #121212;
    outline: none;
    box-sizing: border-box;
  }

  > .separator {
    color: #969696;
    font-family: Pretendard;
    font-size: 13px;
  }
`;

export const TextField = styled.div`
  display: flex;
  align-items: center;
  height: 40px;
  min-width: 140px;
  padding: 0 12px;
  border: 1px solid #ccc;
  border-radius: 10px;
  background: #fff;
  box-sizing: border-box;

  > input {
    width: 100%;
    border: none;
    outline: none;
    font-family: Pretendard;
    font-size: 13px;
    font-weight: 500;
    color: #121212;
    background: transparent;
  }

  input::placeholder {
    color: #b7b7b7;
  }
`;

export const ExcelButton = styled.button`
  margin-left: auto;
  height: 40px;
  padding: 0 18px;
  border: none;
  border-radius: 10px;
  background: #7f25fb;
  color: #fff;
  font-family: Pretendard;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const TableContent = styled.div`
  .createdAt {
    width: 14%;
  }
  .nickname {
    width: 12%;
  }
  .missionName {
    width: 18%;
  }
  .logType {
    width: 14%;
  }
  .value {
    width: 12%;
  }
  .memo {
    width: 16%;
  }
  .processor {
    width: 14%;
  }
`;

export const TableHeader = styled.div`
  display: flex;
  width: 100%;
  padding: 8px 12px;
  box-sizing: border-box;
  border-bottom: 1px solid #e5e5e5;

  > .item {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #121212;
    font-family: Pretendard;
    font-size: 13px;
    font-weight: 600;
    text-align: center;
  }
`;

export const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 480px;
`;

export const TableItem = styled.div`
  width: 100%;
  display: flex;
  min-height: 52px;
  padding: 10px 12px;
  box-sizing: border-box;
  border-bottom: 1px solid #f0f0f0;
  align-items: center;

  &:last-child {
    border-bottom: none;
  }

  > .item {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Pretendard;
    font-size: 13px;
    font-weight: 500;
    color: #121212;
    text-align: center;
    word-break: keep-all;
    padding: 0 4px;
  }

  > .item.logType.positive {
    color: #7f25fb;
    font-weight: 700;
  }

  > .item.logType.cancel {
    color: #d91818;
    font-weight: 700;
  }
`;

export const EmptyMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: #969696;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 500;
`;
